export const ieltsWords = [
  {
    word: "significant",
    image: "https://images.unsplash.com/photo-1609840117091-0e2ed65d5c2a",
    synonyms: ["important", "notable", "meaningful"],
    example: "There has been a significant increase in pollution levels.",
    definition: "Important or large enough to be noticed or have an effect."
  },
  {
    word: "issue",
    image: "https://images.unsplash.com/photo-1518609878373-06d740f60d8b",
    synonyms: ["problem", "topic", "concern"],
    example: "Climate change is a major global issue.",
    definition: "An important topic or problem for debate or discussion."
  },
  {
    word: "impact",
    image: "https://images.unsplash.com/photo-1615719413546-0a3abfe3521c",
    synonyms: ["effect", "influence", "consequence"],
    example: "The new law had a positive impact on the economy.",
    definition: "The strong effect or influence something has."
  },
  {
    word: "trend",
    image: "https://images.unsplash.com/photo-1581091012184-0f3b05caa399",
    synonyms: ["pattern", "movement", "direction"],
    example: "There is a growing trend towards remote work.",
    definition: "A general direction in which something is developing or changing."
  },
  {
    word: "alternative",
    image: "https://images.unsplash.com/photo-1580891012184-0f3b05caa399",
    synonyms: ["option", "choice", "substitute"],
    example: "We need to find alternative sources of energy.",
    definition: "Something different that can be used instead of another thing."
  },
  {
    word: "urban",
    image: "https://images.unsplash.com/photo-1532634896-26909d0d8b97",
    synonyms: ["city", "metropolitan", "municipal"],
    example: "Urban areas are often more polluted than rural ones.",
    definition: "Related to towns or cities."
  },
  {
    word: "rural",
    image: "https://images.unsplash.com/photo-1607623814075-fb6ebcf50fb4",
    synonyms: ["countryside", "agricultural", "non-urban"],
    example: "Many people prefer living in rural areas for the peace and quiet.",
    definition: "Related to the countryside rather than the city."
  },
  {
    word: "factor",
    image: "https://images.unsplash.com/photo-1614642264761-69012d9d3ff6",
    synonyms: ["element", "component", "aspect"],
    example: "Many factors contribute to global warming.",
    definition: "One of the things that cause or influence a result."
  },
  {
    word: "income",
    image: "https://images.unsplash.com/photo-1549921296-3a6b450e979e",
    synonyms: ["earnings", "salary", "revenue"],
    example: "High-income families can afford better education.",
    definition: "Money received, especially on a regular basis, for work or investments."
  },
  {
    word: "consume",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    synonyms: ["use", "devour", "expend"],
    example: "Modern societies consume a lot of energy.",
    definition: "To use up a resource or product."
  },
  {
    word: "environment",
    image: "https://images.unsplash.com/photo-1606326608697-11bc8a57b9c6",
    synonyms: ["surroundings", "nature", "ecosystem"],
    example: "Protecting the environment is a global responsibility.",
    definition: "The natural world, including air, water, and land."
  },
  {
    word: "sustainability",
    image: "https://images.unsplash.com/photo-1609840117091-0e2ed65d5c2a",
    synonyms: ["stability", "endurance", "renewability"],
    example: "Sustainability is key to protecting our future.",
    definition: "The ability to continue at the same level without harming the environment."
  },
  {
    word: "influence",
    image: "https://images.unsplash.com/photo-1529243856184-fd5465488984",
    synonyms: ["affect", "shape", "sway"],
    example: "Parents have a strong influence on their children’s behavior.",
    definition: "The power to affect how someone or something develops."
  },
  {
    word: "increase",
    image: "https://images.unsplash.com/photo-1580894894512-399f1d878362",
    synonyms: ["grow", "rise", "expand"],
    example: "There has been an increase in the number of tourists.",
    definition: "To become larger in number, amount, or degree."
  },
  {
    word: "decrease",
    image: "https://images.unsplash.com/photo-1610440447046-1ec1e0b69995",
    synonyms: ["reduce", "drop", "decline"],
    example: "Air pollution has decreased in recent years.",
    definition: "To become smaller in number or amount."
  },
  {
    word: "education",
    image: "https://images.unsplash.com/photo-1509223197845-458d87318791",
    synonyms: ["learning", "schooling", "instruction"],
    example: "Access to education is crucial for development.",
    definition: "The process of teaching and learning."
  },
  {
    word: "developing",
    image: "https://images.unsplash.com/photo-1589830702597-1c996f48f3c4",
    synonyms: ["growing", "emerging", "advancing"],
    example: "Developing countries face many challenges.",
    definition: "In the process of becoming more advanced economically or socially."
  },
  {
    word: "transportation",
    image: "https://images.unsplash.com/photo-1614644147722-2a2b9ef59b25",
    synonyms: ["travel", "logistics", "transit"],
    example: "Public transportation reduces traffic congestion.",
    definition: "The system of moving people or goods from place to place."
  },
  {
    word: "government",
    image: "https://images.unsplash.com/photo-1614206554084-5c85edec4e2b",
    synonyms: ["administration", "authority", "leadership"],
    example: "The government announced a new education policy.",
    definition: "The group of people who control and make decisions for a country or area."
  },
  {
    word: "solution",
    image: "https://images.unsplash.com/photo-1584697964154-993fdde9ba74",
    synonyms: ["answer", "remedy", "resolution"],
    example: "Solar energy is a solution to energy shortages.",
    definition: "A way of solving a problem."
  },
  {
    word: "challenge",
    image: "https://images.unsplash.com/photo-1610440447046-1ec1e0b69995",
    synonyms: ["difficulty", "obstacle", "test"],
    example: "Climate change is one of the biggest global challenges.",
    definition: "A task or situation that requires great effort to deal with."
  },
  {
    word: "global",
    image: "https://images.unsplash.com/photo-1529243856184-fd5465488984",
    synonyms: ["worldwide", "international", "universal"],
    example: "We live in a global economy.",
    definition: "Relating to the whole world."
  },
  {
    word: "priority",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
    synonyms: ["importance", "urgency", "focus"],
    example: "Education should be a national priority.",
    definition: "Something that is considered more important than other things."
  },
  {
    word: "technology",
    image: "https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d",
    synonyms: ["innovation", "tech", "science"],
    example: "Technology is changing the way we work.",
    definition: "The use of scientific knowledge to improve life."
  },
  {
    word: "access",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    synonyms: ["entry", "availability", "reach"],
    example: "Not everyone has access to clean water.",
    definition: "The ability to use or enter something."
  }
];
